import React, { useEffect } from "react";
import ModernNavbar from "../components/modern-navbar";
import ModernFooter from "../components/modern-footer";

const Support = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="modern-landing">
      <ModernNavbar />

      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <h1>Support</h1>
            <p>
              Get help when you need it. Our support team is here to assist you.
            </p>
          </div>
        </div>
      </section>

      <section className="support-section">
        <div className="container">
          <div className="support-grid">
            <div className="support-card">
              <h3>📧 Email Support</h3>
              <p>Send us an email and we'll get back to you within 24 hours.</p>
              <a href="mailto:support@optimus.com" className="btn-outline">
                Contact Support
              </a>
            </div>
            <div className="support-card">
              <h3>📚 Documentation</h3>
              <p>Find answers in our comprehensive documentation.</p>
              <a href="/documentation" className="btn-outline">
                View Docs
              </a>
            </div>
            <div className="support-card">
              <h3>💬 Live Chat</h3>
              <p>Chat with our support team in real-time.</p>
              <a href="/contact" className="btn-outline">
                Start Chat
              </a>
            </div>
          </div>
        </div>
      </section>

      <ModernFooter />
    </div>
  );
};

export default Support;
